export const TEXT = {
  completed: 'Completed. Click to mark as uncompleted',
  uncompleted: 'Uncompleted. Click to mark as completed',
};
